import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "用于管理机构信息", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_bind_permission = _resolveComponent("bind-permission");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.uac.org.list,
    columns: $data.columns,
    topButtons: $data.topButtons,
    linkButtons: $data.linkButtons,
    showPagination: false,
    selectionEnable: false,
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "linkButtons"]), _createVNode(_component_el_dialog, {
    modelValue: $data.bindPermissionDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.bindPermissionDialog = $event),
    title: "分配权限",
    "destroy-on-close": "",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [_createVNode(_component_bind_permission, {
      org: $data.currentOrg,
      onOnClose: _cache[0] || (_cache[0] = $event => $data.bindPermissionDialog = false),
      onOnSubmit: $options.doBindPermission
    }, null, 8, ["org", "onOnSubmit"])]),
    _: 1
  }, 8, ["modelValue"])]);
}